import type { SelectProps } from '@cloudscape-design/components/select';

export type Option = SelectProps.Option;

export interface WebApplicationState {
  application: {
    organisationName: string;
    applicationName: string;
    environment: Option;
    namespace: string;
  };
  details: {
    nodepool: Option;
    resources_requests_cpu: string;
    resources_requests_memory: string;
    resources_limits_cpu: string;
    resources_limits_memory: string;
    scale_min_replicas: string;
    scale_max_replicas: string;
    scale_target_utilization: string;
    scale_rps_threshold: string;
  };
  deployment: {
    containers_name: string;
    containers_image: string;
    containers_tag: string;
    container_port: string;
    replicas: string;
    image_pull_policy: Option;
    service_account_name: string;
    environment_variables: string;
  };
  service: {
    name: string;
    type: Option;
    port: string;
    target_port: string;
    protocol: Option;
    ingress_enabled: boolean;
    hostname: string;
    ingress_host: string;
    ingress_path: string;
    rps_threshold: string;
  };
}

export interface WebApplicationIntent {
  kind: 'web-application';
  version: 'v1';
  state: WebApplicationState;
}

export const ENVIRONMENTS: Option[] = [
  { value: 'dev', label: 'Development' },
  { value: 'stage', label: 'Staging' },
  { value: 'prod', label: 'Production' },
];

export const NODEPOOLS: SelectProps.Options = [
  {
    label: 'CPU',
    options: [
      { value: 'spot', label: 'Spot' },
      { value: 'on-demand', label: 'On-Demand' },
    ],
  },
  {
    label: 'General purpose',
    options: [
      { value: 'general-spot', label: 'Spot' },
      { value: 'general-on-demand', label: 'On-Demand' },
    ],
  },
];

export const SERVICE_TYPES: Option[] = [
  { value: 'ClusterIP', label: 'ClusterIP' },
  { value: 'NodePort', label: 'NodePort' },
  { value: 'LoadBalancer', label: 'LoadBalancer' },
];

export const IMAGE_PULL_POLICIES: Option[] = [
  { value: 'IfNotPresent', label: 'IfNotPresent' },
  { value: 'Always', label: 'Always' },
  { value: 'Never', label: 'Never' },
];

export const PROTOCOLS: Option[] = [{ value: 'TCP', label: 'TCP' }];

export const DEFAULT_WEB_APP_STATE: WebApplicationState = {
  application: {
    organisationName: 'new-co',
    applicationName: 'new-web-app',
    environment: ENVIRONMENTS[0],
    namespace: 'tcf-applications',
  },
  details: {
    nodepool: { value: 'spot', label: 'Spot' },
    resources_requests_cpu: '1',
    resources_requests_memory: '1',
    resources_limits_cpu: '2',
    resources_limits_memory: '2',
    scale_min_replicas: '1',
    scale_max_replicas: '5',
    scale_target_utilization: '50',
    scale_rps_threshold: '20',
  },
  deployment: {
    containers_name: 'new-web-app',
    containers_image: 'warrenwb/new-app-no-json',
    containers_tag: 'v0.0.1',
    container_port: '8080',
    replicas: '2',
    image_pull_policy: IMAGE_PULL_POLICIES[0],
    service_account_name: 'new-web-app-sa',
    environment_variables: 'LOG_LEVEL=info',
  },
  service: {
    name: 'new-web-app-service',
    type: SERVICE_TYPES[0],
    port: '80',
    target_port: '8080',
    protocol: PROTOCOLS[0],
    ingress_enabled: false,
    hostname: 'new-web-app.ncoda.ai',
    ingress_host: '',
    ingress_path: '/',
    rps_threshold: '20',
  },
};
